<div class="close">
  <img src ='../../assets/images/popclose.png' (click)='closeModel()'>
</div>
<h3>Upload Profile Picture</h3>

<div class="crop_container">
  <image-cropper
  [imageChangedEvent]="imageChangedEvent"
  [maintainAspectRatio]="true"
  [aspectRatio]="4 / 3"
  [resizeToWidth]="200"
  format="png"
  (imageCropped)="imageCropped($event)"

style='width:300px;'></image-cropper>
<!-- <img [src]="croppedImage" /> -->

</div>

<div class="text-right d-flex align-items-center justify-content-end">
<button mat-stroked-button  class="uploadBtn mr-2">
<form [formGroup]='image'>
  <input type='file' formControlName='file' class="import_button" (change)="fileChangeEvent($event)">{{!imageChangedEvent ? 'Choose' :'Change'}} Image
</form>
</button>
<button mat-stroked-button color="primaryCus"  (click)='uploadImage()'>
Upload
</button>
<div class="tooltipImg ml-3">
  <img src="assets/images/i.svg" alt="" [title]='instructionString'>
</div>
</div>


